export default "__VITE_ASSET__$ZaHRZvv__"